import React from 'react';
import Button from '../../../components/ui/Button';
import AppIcon from '../../../components/AppIcon';
import { useTranslation } from 'react-i18next';

const AssignmentTypeSelectionModal = ({ onClose, onAssignToEmployee, onAssignToDepartment }) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <div className="bg-card rounded-xl border border-border shadow-2xl w-full max-w-md flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div>
            <h2 className="text-xl font-semibold text-foreground">Choose Assignment Type</h2>
            <p className="text-sm text-muted-foreground mt-1">
              Select whether to assign the asset to an employee or a department.
            </p>
          </div>
          <Button variant="ghost" size="sm" iconName="X" onClick={onClose} />
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <button
            onClick={onAssignToEmployee}
            className="w-full flex items-start gap-4 p-4 rounded-xl border border-border bg-card hover:border-primary hover:shadow-md transition-all text-left group"
          >
            <div className="p-3 bg-primary/10 text-primary rounded-lg shrink-0 group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
              <AppIcon name="User" size={24} />
            </div>
            <div>
                <h3 className="text-base font-medium text-foreground">Assign to Employee</h3>
                <p className="text-sm text-muted-foreground mt-1">Assign the asset to a specific individual.</p>
            </div>
          </button>

          <button
            onClick={onAssignToDepartment}
            className="w-full flex items-start gap-4 p-4 rounded-xl border border-border bg-card hover:border-primary hover:shadow-md transition-all text-left group"
          >
            <div className="p-3 bg-primary/10 text-primary rounded-lg shrink-0 group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
              <AppIcon name="Building" size={24} />
            </div>
            <div>
              <h3 className="text-base font-medium text-foreground">Assign to Department</h3>
              <p className="text-sm text-muted-foreground mt-1">Assign the asset to an entire department.</p>
            </div>
          </button>
        </div>

        {/* Footer */}
        <div className="flex justify-end p-6 border-t border-border">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AssignmentTypeSelectionModal;